<lib-form-field-container
    #anchor
    [kind]="FormContainerKind.Chips"
    [isOptional]="isOptional"
    [hideErrors]="hideErrors || (autocomplete ? autocomplete.panelOpen : false)"
    (fieldClicked)="Clicked($event)"
    (containerClicked)="Blur()"
    (mousedown)="$event.preventDefault()">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-content
        prefixText
        select="[prefixText]"></ng-content>
    <ng-content
        suffixText
        select="[suffixText]"></ng-content>
    <ng-content
        menu
        select="[menu]"></ng-content>

    <ng-container readOnly>
        <div
            class="wrapper-content"
            #providedReadOnly>
            <ng-content select="[readOnly]"></ng-content>
        </div>
        @if (isReadOnly) {
            <div class="default-content d-flex flex-row">
                <ng-container *ngFor="let item of selectedItems; let last = last">
                    <div *ngTemplateOutlet="item.selectLabel"></div>
                    <div>{{ last ? '' : ',&nbsp;' }}</div>
                </ng-container>
                @if (selectedItems.size === 0) {
                    <ng-container i18n="@@CommonNotSpecifiedLabel">Not specified</ng-container>
                }
            </div>
        }
    </ng-container>

    <ng-content
        bottomMenu
        select="[bottomMenu]"></ng-content>

    @if (showQuickSelect && !isReadOnly) {
        <lib-menu-button
            menu
            [disabled]="isDisabled"
            [kind]="ButtonKind.Link">
            <ng-container
                label
                i18n="@@CommonQuickSelectLabel">
                Quick Select
            </ng-container>
            <lib-menu-item
                i18n-label="@@CommonQuickSelectClearLabel"
                label="Clear"
                [stopPropagation]="true"
                [qaTag]="qaTag + '-clear-all'"
                (clicked)="ClearAll()"></lib-menu-item>
            <lib-menu-item
                i18n-label="@@CommonQuickSelectSelectAllLabel"
                label="Select All"
                [stopPropagation]="true"
                [qaTag]="qaTag + '-select-all'"
                (clicked)="SelectAll()"></lib-menu-item>
        </lib-menu-button>
    }

    @if (!isLoading && !isReadOnly) {
        <div
            [attr.data-sb-qa]="qaTag ? qaTag + '-selection-area' : ''"
            class="d-flex flex-column"
            [style.width]="selectedItems && selectedItems.size > 0 ? 'calc(100% - 40px)' : '100%'">
            <mat-chip-grid
                #chipGrid
                [id]="formFieldID"
                                [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                                                                [attr.aria-label]="ariaLabel || null"
                                                                [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
                                [attr.aria-required]="formControl.isRequired"
                [disabled]="isDisabled">
                <mat-chip-row
                    *ngFor="let item of selectedItems"
                    [editable]="false"
                    (removed)="Remove(item)"
                    (mousedown)="$event.stopPropagation()"
                    (click)="ChipSelected(item, $event)">
                    <span>
                        @if (item?.selectLabel) {
                            <ng-container *ngTemplateOutlet="item.selectLabel"></ng-container>
                        }
                    </span>
                    @if (allowChipDeletion) {
                        <lib-icon-button
                            matChipRemove
                            [qaTag]="item.qaTag ? item.qaTag + '_Icon_Button_Remove' : ''"
                            [kind]="ButtonKind.NeutralTertiary"
                            [icon]="Icon.Common.Close"
                            [size]="ButtonSize.Small"></lib-icon-button>
                    }
                </mat-chip-row>
            </mat-chip-grid>

            <input
                #input
                [formControl]="viewControl"
                [placeholder]="chipsPlaceholderText ?? ''"
                [matChipInputFor]="chipGrid"
                [matAutocomplete]="auto"
                [matAutocompleteConnectedTo]="anchor?.origin!"
                [attr.data-sb-qa]="qaTag ? qaTag + '-input' : ''"
                (change)="$event.stopPropagation()"
                (blur)="Clear()" />

            <mat-autocomplete
                #auto="matAutocomplete"
                (opened)="PanelOpened()">
                @for (groupItems of filteredItemsByGroup | async | keyvalue: keepOrder; track groupItems.key) {
                    @if (!groupItems.key) {
                        @for (item of groupItems.value; track item.value) {
                            <mat-option
                                [attr.data-sb-qa]="item.qaTag + '_NoKey'"
                                [value]="item"
                                class="v3"
                                (mousedown)="$event.preventDefault()">
                                <div
                                    class="sb-option-click-target"
                                    (click)="$event.stopImmediatePropagation(); Selected(item)"></div>
                                <ng-container *ngTemplateOutlet="panelItem; context: { $implicit: item }"></ng-container>
                            </mat-option>
                        }
                    } @else if (groupItems.value.length) {
                        <mat-optgroup
                            class="select-text"
                            [label]="groupItems.key.name">
                            @for (item of groupItems.value; track item.value) {
                                <mat-option
                                    [attr.data-sb-qa]="item.qaTag + '_InOptGroup'"
                                    [value]="item"
                                    class="v3"
                                    (mousedown)="$event.preventDefault()">
                                    <div
                                        class="sb-option-click-target"
                                        (click)="$event.stopImmediatePropagation(); Selected(item)"></div>
                                    <ng-container *ngTemplateOutlet="panelItem; context: { $implicit: item }"></ng-container>
                                </mat-option>
                            }
                        </mat-optgroup>
                    }
                }
            </mat-autocomplete>
        </div>
    }

    <ng-container suffixIcon>
        @if (formControl?.value!.length) {
            <lib-icon-button
                [icon]="Icon.Common.Close"
                [kind]="ButtonKind.FormField"
                [size]="ButtonSize.Large"
                [disabled]="isDisabled"
                matTooltip="Clear"
                i18n-matTooltip="@@CommonClearLabel"
                (clicked)="ClearAll()"></lib-icon-button>
        } @else {
            <lib-icon-button
                [kind]="ButtonKind.FormField"
                [size]="ButtonSize.Large"
                [disabled]="isDisabled"
                [icon]="autocomplete && autocomplete.panelOpen ? Icon.Common.CaretUp : Icon.Common.CaretDown"
                (clicked)="autocomplete && autocomplete.panelOpen ? autocomplete.closePanel() : autocomplete.openPanel()"></lib-icon-button>
        }
    </ng-container>
</lib-form-field-container>

<ng-template
    #panelItem
    let-item>
    <div
        class="sb-panel-item-wrapper w-100"
        >
            <ng-container *ngTemplateOutlet="item.selectLabel"></ng-container>
            <small class="sb-panel-supporting-text"
                #caption
                [hidden]="!caption.textContent?.trim()">
                <ng-container *ngTemplateOutlet="item.selectSupportingText"></ng-container>
            </small>
    </div>
</ng-template>
